var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "pt-1", attrs: { lg: "12", "offset-lg": "0" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-tabs",
                        {
                          attrs: { card: "" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "b-tab",
                            { attrs: { title: _vm.$t("titles.current") } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("table.headers.filename"),
                                        "label-for": "input-1",
                                        horizontal: "",
                                        "label-cols": 2
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.currentTemplate.Filename,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.currentTemplate,
                                              "Filename",
                                              $$v
                                            )
                                          },
                                          expression: "currentTemplate.Filename"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("table.headers.user"),
                                        "label-for": "input-1",
                                        horizontal: "",
                                        "label-cols": 2
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: (
                                            _vm.currentTemplate.User || {}
                                          ).Email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.currentTemplate.User || {},
                                              "Email",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "(currentTemplate.User || {}).Email"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("table.headers.created"),
                                        "label-for": "input-1",
                                        horizontal: "",
                                        "label-cols": 2
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.currentTemplateCreated,
                                          callback: function($$v) {
                                            _vm.currentTemplateCreated = $$v
                                          },
                                          expression: "currentTemplateCreated"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "table.headers.description"
                                        ),
                                        "label-for": "input-1",
                                        horizontal: "",
                                        "label-cols": 2
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value:
                                            _vm.currentTemplate.Description,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.currentTemplate,
                                              "Description",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "currentTemplate.Description"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "",
                                        horizontal: "",
                                        "label-cols": 2
                                      }
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { md: "12", lg: "2" } },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "outline-primary",
                                                    block: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.download(
                                                        _vm.currentTemplate
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "buttons.download"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: _vm.$t("titles.upload") } },
                            [
                              _c(
                                "form",
                                {
                                  attrs: {
                                    enctype: "multipart/form-data",
                                    onsubmit: "return false"
                                  },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.validateBeforeSubmit.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("b-form-file", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      accept: ".csv",
                                      placeholder: _vm.$t("form.placeholder"),
                                      change: _vm.reset()
                                    },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-form-textarea",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                "required:true|min:20|max:500|upload_description",
                                              expression:
                                                "'required:true|min:20|max:500|upload_description'"
                                            }
                                          ],
                                          staticClass: "mb-3",
                                          attrs: {
                                            name: "description",
                                            disabled: _vm.formDisabled
                                          },
                                          model: {
                                            value: _vm.description,
                                            callback: function($$v) {
                                              _vm.description = $$v
                                            },
                                            expression: "description"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    >\n\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.errors.has("description")
                                        ? _c("span", { staticClass: "error" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first("description")
                                              )
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.stateInitial || _vm.stateUploading
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            block: "",
                                            variant: "success",
                                            type: "submit",
                                            disabled: _vm.formDisabled
                                          }
                                        },
                                        [
                                          _vm.stateUploading
                                            ? _c(
                                                "div",
                                                [
                                                  _c("font-awesome-icon", {
                                                    style: { color: "white" },
                                                    attrs: {
                                                      icon: "spinner",
                                                      spin: "",
                                                      transform: ""
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "buttons.uploading"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.stateInitial
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t("buttons.upload")
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-alert",
                                    {
                                      attrs: {
                                        variant: "success",
                                        show: _vm.stateSuccess,
                                        dismissible: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("alerts.success")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-alert",
                                    {
                                      attrs: {
                                        variant: "danger",
                                        show: _vm.stateError,
                                        dismissible: ""
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("alerts.danger")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: _vm.$t("titles.history") } },
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  items: _vm.templates,
                                  fields: _vm.fields,
                                  small: "",
                                  responsive: "xl"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head(Created.ReferenceUsername)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.created")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(User.Email)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.user")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(Description)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "table.headers.description"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(Actions)",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.actions")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(Created)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.parseDate(data.item.Created)
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(Actions)",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.download(data.item)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("buttons.download")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "danger",
                                              disabled: data.item.FileRank === 1
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.rollbackModal(data)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("buttons.rollback")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rollback-modal",
          attrs: { title: _vm.$t("titles.rollback"), "hide-footer": "" }
        },
        [
          _c("p", { staticClass: "my-4" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("texts.rollback", {
                    name: (this.selectedTemplate || {}).FileName,
                    timestamp: _vm.parseDate(
                      (this.selectedTemplate || {}).Created
                    ),
                    email: ((this.selectedTemplate || {}).User || {}).Email
                  })
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { block: "", variant: "danger" },
              on: { click: _vm.rollback }
            },
            [_vm._v(_vm._s(_vm.$t("buttons.rollback")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-252c23de", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-252c23de","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/TemplateDefinitions.vue
// module id = 766
// module chunks = 0